import React from 'react';
import { Box, TextField } from '@mui/material';
import { useAuthStore } from '../../store/storeAuth';
import Label from '../UI/Label/Label';

interface PullGoogleSlidesDataProps {
  formData: any;
  onChange: (e: any) => void;
}

const PullGoogleSlidesData: React.FC<PullGoogleSlidesDataProps> = ({
  formData,
  onChange,
}) => {
  const { user } = useAuthStore(state => state);

  return (
    <Box width={'360px'}>
      <Box
        sx={{
          margin: '10px 0',
        }}
      >
        <Label
          labelStyle={{ marginTop: '10px' }}
          labelName="Settings"
          isAdvanced
        />

        <TextField
          name="presentationId"
          label="Presentation ID"
          placeholder="Enter Presentation ID"
          value={formData.presentationId}
          onChange={onChange}
          InputProps={{
            style: {
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            },
          }}
          sx={{
            color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
            border: `2px solid ${
              user?.theme === 'dark' ? '#475467' : '#EAECF0'
            }`,
          }}
        />
      </Box>
    </Box>
  );
};

export { PullGoogleSlidesData };
